// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CiCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/CiCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var CiCircleOutlined = function CiCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CiCircleOutlinedSvg
  }));
};

CiCircleOutlined.displayName = 'CiCircleOutlined';
export default React.forwardRef(CiCircleOutlined);